import { Component } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AlertOptions } from '@ionic/core';
import { LodeUserFormDataService } from '../../angular-wallet-base/services/lodeuserformdata.service';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { ComponentCanDeactivate } from '../../angular-wallet-base/services/settingsguard.service';

@Component({
  selector: 'create-account-lode',
  templateUrl: './create-account.page.html',
  styleUrls: ['./create-account.page.scss'],
})
export class CreateAccountPage implements ComponentCanDeactivate {
  public createAccount = true;
  constructor(
    private alertController: AlertController,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private lodeUserFormDataService: LodeUserFormDataService,
    private location: Location,
    private router: Router
  ) {}

  canDeactivate(route: ActivatedRouteSnapshot) {
    return (this.lodeUserFormDataService.newUserForm.dirty) ? this.confirmExit(route) : true;
  }

  async confirmExit(currentRoute): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      this.presentAlert({
        header: '',
        message: await this.translate.get('lode_acc.confirm_exit.msg').toPromise(),
        buttons: [
          {
            text: await this.translate.get('lode_acc.confirm_exit.cancel').toPromise(),
            role: 'cancel',
            handler: () => {
              // Angular issue: Deactivation Guard breaks the routing history #13586
              // https://github.com/angular/angular/issues/13586
              // Workaround:
              // https://stackoverflow.com/questions/47661945/angular-4-candeactivate-fails-if-back-button-is-hit-twice-in-a-row
              const currentUrlTree = this.router.createUrlTree([], currentRoute);
              const currentUrl = currentUrlTree.toString();
              this.location.go(currentUrl);
              resolve(false);
            }
          }, {
            text: await this.translate.get('lode_acc.confirm_exit.yes').toPromise(),
            handler: () => {
              resolve(true);
            }
          }
        ]
      });
    });
  }

  async presentAlert(opts: AlertOptions) {
    if (!opts.buttons) {
      Object.assign(opts, {
        buttons: ['Ok']
      });
    }
    const alert = await this.alertController.create(opts);
    alert.present();
  }
}
